import type { StatCell } from "@sins2-atlas/game-data";
import { clsx } from "clsx";
import { cellTitle, formatStatNumber, STATE_META } from "../lib/stat-cell";

// ADR 0003 made visible — the quiet-glyph cell system (design language, confirmed
// 2026-07-27): Computed shows the value; the three non-Computed states show a distinct glyph
// in a distinct treatment, never 0, never blank. The dotted underline + cursor:help marks
// "there is honesty language one layer down" (the title).
export function StatCellView({
  cell,
  format = formatStatNumber,
}: {
  cell: StatCell;
  /** Override for columns where 4-significant-digit rounding would misstate the value
   * (exact resource prices). */
  format?: (value: number) => string;
}) {
  const title = cellTitle(cell);
  if (cell.state === "computed") {
    return (
      <span
        className={clsx(
          title !== "" &&
            "cursor-help underline decoration-muted decoration-dotted underline-offset-2",
        )}
        title={title === "" ? undefined : title}
      >
        {format(cell.value)}
      </span>
    );
  }
  return (
    <span
      className={clsx(
        "cursor-help underline decoration-dotted underline-offset-2",
        cell.state === "formula_unverified" ? "text-unverified" : "text-muted-2",
      )}
      title={title}
    >
      {STATE_META[cell.state].glyph}
    </span>
  );
}
